/* Atelier — contact form: remembers the chosen subject across Shopify's post/redirect
   so the thank-you panel can show it, and restores it if the form comes back with errors. */
if (!customElements.get('atelier-contact')) {
  customElements.define(
    'atelier-contact',
    class AtelierContact extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.storageKey = 'atelier-contact-subject-' + (this.dataset.sectionId || '');

        const form = this.querySelector('form');
        const radios = form ? Array.from(form.querySelectorAll('input[name="contact[subject]"]')) : [];

        if (radios.length) {
          if (this.querySelector('.at-contact__errors')) {
            const saved = this.read();
            const match = radios.find((radio) => radio.value === saved);
            if (match) match.checked = true;
          }
          form.addEventListener('submit', () => {
            const checked = radios.find((radio) => radio.checked);
            this.write(checked ? checked.value : '');
          });
        }

        const subject = this.querySelector('[data-subject]');
        if (subject) {
          const value = this.read();
          const out = subject.querySelector('[data-subject-value]');
          if (value && out) {
            out.textContent = value;
            subject.hidden = false;
          }
        }

        // "Send another message": return to the form, keeping any other query params (e.g. ?view=).
        const again = this.querySelector('.at-contact__again');
        if (again && window.location.search.indexOf('contact_posted') !== -1) {
          const params = new URLSearchParams(window.location.search);
          params.delete('contact_posted');
          const query = params.toString();
          const hash = again.getAttribute('href').split('#')[1];
          again.setAttribute('href', window.location.pathname + (query ? '?' + query : '') + (hash ? '#' + hash : ''));
        }
      }

      read() {
        try {
          return window.sessionStorage.getItem(this.storageKey) || '';
        } catch (error) {
          return '';
        }
      }

      write(value) {
        try {
          window.sessionStorage.setItem(this.storageKey, value);
        } catch (error) {
          /* storage unavailable: the thank-you panel simply omits the subject line */
        }
      }
    }
  );
}
